var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delivery-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #02b3ad;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    className: "cls-1",
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fast-delivery",
    className: "cls-3",
    d: "M11.877,3.447,13.839,4.58,7.734,8.1V10.88L9.5,11.9V9.127L15.61,5.6l1.962,1.133a.4.4,0,0,1,.2.355v3.732A4.323,4.323,0,0,0,12.928,16.7l-1.051.607a.4.4,0,0,1-.41,0L6.135,14.231H.918a.328.328,0,1,1,0-.656H5.567V10.706H2.537a.328.328,0,1,1,0-.656h3.03V7.181H.918a.328.328,0,0,1,0-.656H6.135l4.294-2.479H8.215a.328.328,0,0,1,0-.656h3.457a.41.41,0,0,1,.2.057Zm5.048,7.946a3.665,3.665,0,1,0,3.665,3.665A3.665,3.665,0,0,0,16.925,11.393ZM19,14.346c-.723.729-1.441,1.464-2.167,2.19a.544.544,0,0,1-.769,0l-1.2-1.2a.544.544,0,0,1,.769-.769l.819.819,1.782-1.8a.543.543,0,0,1,.77.765ZM6.172,3.39H2.537a.328.328,0,0,0,0,.656H6.172a.328.328,0,0,0,0-.656Z",
    transform: "translate(-0.59 -1.057)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/deliveryIcon.804f49638bce780578b2f23138ecb2e4.svg";
export { ForwardRef as ReactComponent };